import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  setOutputField,
  deleteOutputNode,
  resetOutputNode,
} from 'actions/feature/outputs'
import { getIsDeletableOutput } from 'selectors/feature/outputs'
import { getLogicNodesMetaByFunction } from 'selectors/feature/logicNodes'
import OutputNodeEditor from './OutputNodeEditor'

const makeMapStateToProps = () => (state, ownProps) => {
  const { parentId: fnId, featureModuleType } = ownProps
  const validOutputQueryUris = getLogicNodesMetaByFunction(state, { id: fnId })
  const isDeletable = getIsDeletableOutput(state, { id: fnId })

  return {
    ...ownProps,
    validOutputQueryUris,
    featureModuleType,
    isDeletable,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { id, parentId: fnId } = ownProps

  return {
    ...bindActionCreators(
      {
        deleteOutputNode: () => deleteOutputNode(id, fnId),
        resetOutputNode: () => resetOutputNode(id),
        toggleMarkForDeletion: (toDelete) =>
          setOutputField('markedForDeletion', toDelete, id),
        updateNumberOfBits: (event) =>
          setOutputField('numberOfBits', event.target.value, id),
        setOutputType: (event) =>
          setOutputField('type', event.target.value, id, fnId), // fnId is needed because it's a type change
      },
      dispatch
    ),
  }
}

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(OutputNodeEditor)
